<template>
    <b-container>
        <b-row style="text-align:left">
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Processo:</span>
                    <span style="margin-left:5px">{{ processo.Numero }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Assunto:</span>
                    <span style="margin-left:5px">{{ processo.Assunto }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Data de Entrada:</span>
                    <span style="margin-left:5px">{{ formatData(processo.DataEntrada) }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Unidade Gestora:</span>
                    <span style="margin-left:5px">{{ processo.UnidadeGestora }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Tipo do Processo:</span>
                    <span style="margin-left:5px">{{ processo.TipoDocumento }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Área Atual:</span>
                    <span style="margin-left:5px">{{ processo.AreaAtual }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Situação Atual:</span>
                    <span style="margin-left:5px">{{ processo.SituacaoAtual }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Relator:</span>
                    <span style="margin-left:5px">{{ processo.Relator ? processo.Relator : 'Não Informado' }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Prioritário:</span>
                    <span style="margin-left:5px"> {{ processo.Prioritario ? "Sim" : "Não" }}</span>
                </b-form-group>
            </b-col>
            <b-col v-if="processo.cancelado" cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Motivo Cancelamento:</span>
                    <span style="margin-left:5px"> {{ processo.MotivoCancelamento }}</span>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { UtilsTS } from '@/utilsts'

export default {
    name: 'DetalheProcesso',
    mixins: [UtilsTS],
    props: ["processo"]
}
</script>
<style>
</style>


